import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client";
const GRAPHQL_URL = process.env.REACT_APP_NOTIFICATION_GRAPHQL_URL ||
    "https://api.apexnova.vc/graphql";
const client = new ApolloClient({
    link: new HttpLink({ uri: GRAPHQL_URL }),
    cache: new InMemoryCache(),
});
export default client;
